/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Subtitle_Max_Lines_HelpInputs */



/**
* | output |
* | --- |
* | "Lines per subtitle (1-4)" |
*
* @param {Audio_Description_Export_Subtitle_Max_Lines_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_subtitle_max_lines_help = /** @type {((inputs?: Audio_Description_Export_Subtitle_Max_Lines_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Subtitle_Max_Lines_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lignes par sous-titre (1-4)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilen pro Untertitel (1-4)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Righe per sottotitolo (1-4)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество строк в субтитрах (1-4)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Líneas por subtítulo (1-4)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每条字幕的行数（1-4行）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕の行数（1～4）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक में पंक्तियों की संख्या (1-4)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linhas por legenda (1-4)")
	return /** @type {LocalizedString} */ ("Lines per subtitle (1-4)")
});